import React, { useState } from 'react';
import { AddFaqCategory } from '../../pages';
import * as yup from 'yup';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';
import { SupportController } from '../../controllers';

const AddFaqCategoryContainer = ({ closeModal, data }) => {
    const [loading, setLoading] = useState(false);
    const validationSchema = () => {
        return (
            yup.object().shape({
                name: yup.string().required("Enter category name"),
            })
        )
    }

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = {
            name: values.name,
            order: values.order,
        }
        const { status, errorMessage } = await SupportController.createFaqCategory(payload);
        if (status === constant.Success) {
            SupportController.getFaqs();
            MimaToastUtil.success({ message: constant.Success })
            setLoading(false);
            return closeModal();
        } else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }
    return (
        <AddFaqCategory
            validationSchema={validationSchema}
            loading={loading}
            closeModal={closeModal}
            data={data}
            onSubmit={onSubmit}
        />
    )
}
export default AddFaqCategoryContainer;